// Autogenerated file
export const integrationClientFlagsEnum = {
    SimplifiedCatalogs: "SimplifiedCatalogs",
};
export const integrationClientFlags = [
    { label: "Упрощенное создание заявки", value: "SimplifiedCatalogs", intValue: 1 },
];
